import {
  getAccountCreationSettings,
  getQuicktravelUrl,
  getSeaLinkBasename,
} from 'utils/helpers';

const basename = getSeaLinkBasename();
const quicktravelUrl = getQuicktravelUrl();
const {
  loginSettings: { hideLogin, linkText, additionalLinks } = {},
  hideAccount,
} = window.ecom.craftConfig?.features || {};
const additionalLinksArray =
  additionalLinks?.map((item) => ({
    name: item.linkText,
    path: item.linkUrl,
    iconClass: `far ${item.icon || 'fa-user'}`,
    target: item.linkTarget,
  })) || [];
const visitorNavigation = [];

if (!hideAccount) {
  visitorNavigation.unshift({
    name: 'Manage my booking',
    path: `/${basename}/secure-payment`,
    iconClass: 'far fa-ticket-alt',
  });
}

if (!hideAccount && !hideLogin) {
  const navigationItems = [
    {
      name: linkText || 'Log in',
      path: `/${basename}/account/login`,
      iconClass: 'far fa-user',
    },
    ...additionalLinksArray,
  ];

  // Only add Create Account link if account creation is enabled
  if (getAccountCreationSettings().enabled) {
    navigationItems.unshift({
      name: 'Create an Account',
      path: `/${basename}/account/create-account`,
      iconClass: 'far fa-user-plus',
    });
  }

  visitorNavigation.unshift(...navigationItems);
}

const loggedInUserNavigation = [
  {
    name: 'My account',
    path: `/${basename}/account`,
    iconClass: 'far fa-user',
  },
  {
    name: 'Log out',
    path: `/${basename}/account/logout`,
    iconClass: 'far fa-sign-out',
  },
];

const vendorUserNavigation = [
  {
    name: 'My account',
    path: `/${basename}/account`,
    iconClass: 'far fa-user',
  },
  {
    name: 'Manage allotments',
    path: `${quicktravelUrl}/services/vendor_listing`,
    externalUrl: true,
    iconClass: 'far fa-clipboard-list',
  },
  {
    name: 'Log out',
    path: `/${basename}/account/logout`,
    iconClass: 'far fa-sign-out',
  },
];

export const getUserNavigationLinks = (isLoggedIn, vendorId) => {
  if (!isLoggedIn) {
    return visitorNavigation;
  }

  if (vendorId) {
    return vendorUserNavigation;
  }

  return loggedInUserNavigation;
};
